import { strategies as ceStrategies } from '~/work_items/board/grouping/strategies';
import { statusStrategy } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/work_items/board/grouping/status_strategy.js?vue3';

export const strategies = [...ceStrategies, statusStrategy];
